/* globals data, secondaryFilterHtml */
import Table from 'bam-node-savant-table/table'
import { guff } from 'bam-node-baseball-savant/utils/guff'

const tableDivId = 'fielding_run_value_table'

let currentData = data.slice()

function formatIp(outs) {
    if ([null, undefined, '', 0, '0'].includes(outs)) {
        return '--'
    }

    if (outs < 3) {
        return '<1'
        // return `${Math.floor(outs / 3)}.${outs % 3}`
    }

    return Math.round(outs / 3).toLocaleString()
}

function loadTable(data) {
    const width = document.getElementById(tableDivId).offsetWidth
    let repeatHeader = false
    if (width <= 768) {
        repeatHeader = 15
    }
    const defaultSort = document.getElementById('sort').value
    const defaultSortDirection = document.getElementById('sortDir').value

    // const keys = Object.keys(data[0]).slice(19, 40)

    // const allHeaders = keys.map((key) => ({
    //     name: key,
    //     field: key,
    //     headerClass: 'th-component-header align-center th-vertical-bottom',
    //     fieldClass: 'tr-data',
    //     type: 'number',
    //     displayFn: (val) => {
    //         if (key.includes('rate')) {
    //             return `${(val * 100).toFixed(1)}`
    //         }
    //         if (key.includes('diff')) {
    //             return `${val.toFixed(2)}`
    //         }

    //         if (key.includes('runs')) {
    //             return `${val.toFixed(1)}`
    //         }
    //         return val
    //     },
    // }))

    const headers = [
        {
            name: 'Player',
            field: 'name_display_last_first',
            headerClass: `th-component-header align-left th-vertical-bottom table-static-column`,
            fieldClass: `tr-data align-left table-static-column`,
            defaultSortDir: 'asc',
            displayFn: (name, d) =>
                `<a href="/savant-player/${d.player_id}">${name}</a>`, // what levels of unsafe is this?
        },
        {
            name: 'Team',
            field: 'team_id',
            headerClass: `th-component-header`,
            fieldClass: `tr-data`,
            photo: '<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" onerror="this.onerror=\'\';this.src=\'/site-core/images/savant-mlb.svg\'" />',
            photoId: 'team_id',
            defaultSortDir: 'asc',
            photoOnly: true,
        },
        {
            name: 'Year',
            field: 'year',
            headerClass: `th-component-header align-center th-vertical-bottom table-static-column`,
            fieldClass: `tr-data align-center table-static-column`,
            defaultSortDir: 'desc',
            type: 'number',
            displayFn: (val) => val || 'All',
        },
        {
            name: 'Fielding Run Value',
            field: 'runs_prevented',
            headerClass: `th-component-header align-center th-vertical-bottom border-right`,
            fieldClass: `tr-data align-center border-left border-right`,
            defaultSortDir: 'desc',
            displayFn: (val) => guff(val, 'runs_prevented'),
            type: 'number',
            highlightDynamic: true,
        },
        {
            name: 'All',
            field: 'runs_prevented_fielding',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            displayFn: (val) => guff(val, 'runs_prevented'),
            type: 'number',
        },
        {
            name: 'Range',
            field: 'runs_prevented_on_range',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            displayFn: (val) => guff(val, 'runs_prevented'),
            type: 'number',
        },
        {
            name: 'Arm',
            field: 'runs_prevented_on_arm',
            headerClass: `th-component-header align-center th-vertical-bottom border-right`,
            fieldClass: `tr-data align-center border-right`,
            defaultSortDir: 'desc',
            displayFn: (val) => guff(val, 'runs_prevented'),
            type: 'number',
        },
        {
            name: 'All',
            field: 'runs_prevented_catching',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            displayFn: (val) => guff(val, 'runs_prevented'),
            type: 'number',
        },
        {
            name: 'Framing',
            field: 'runs_prevented_on_framing',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            displayFn: (val) => guff(val, 'runs_prevented'),
            type: 'number',
        },
        {
            name: 'Throwing',
            field: 'runs_prevented_on_stealing',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            displayFn: (val) => guff(val, 'runs_prevented'),
            type: 'number',
        },
        {
            name: 'Blocking',
            field: 'runs_prevented_on_blocks',
            headerClass: `th-component-header align-center th-vertical-bottom border-right`,
            fieldClass: `tr-data align-center border-right`,
            defaultSortDir: 'desc',
            displayFn: (val) => guff(val, 'runs_prevented'),
            type: 'number',
        },
        {
            name: 'Total',
            field: 'Outs',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            displayFn: formatIp,
            type: 'number',
        },
        {
            name: 'C',
            field: 'Outs2',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            displayFn: formatIp,
            type: 'number',
        },
        {
            name: '1B',
            field: 'Outs3',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            displayFn: formatIp,
            type: 'number',
        },
        {
            name: '2B',
            field: 'Outs4',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            displayFn: formatIp,
            type: 'number',
        },
        {
            name: '3B',
            field: 'Outs5',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            displayFn: formatIp,
            type: 'number',
        },
        {
            name: 'SS',
            field: 'Outs6',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            displayFn: formatIp,
            type: 'number',
        },
        {
            name: 'LF',
            field: 'Outs7',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            displayFn: formatIp,
            type: 'number',
        },
        {
            name: 'CF',
            field: 'Outs8',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            displayFn: formatIp,
            type: 'number',
        },
        {
            name: 'RF',
            field: 'Outs9',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data align-center`,
            defaultSortDir: 'desc',
            displayFn: formatIp,
            type: 'number',
        },
    ]

    const secondaryHeaders = [
        {
            name: '',
            colspan: 5,
            headerClass: 'th-name-header',
        },
        {
            name: 'IF / OF',
            colspan: 3,
            headerClass: 'th-title-header',
        },
        {
            name: 'Catching',
            colspan: 4,
            headerClass: 'th-title-header',
        },
        {
            name: `
            <div id="form-secondary" class="form-group" style="display: flex;"> ${secondaryFilterHtml}
            </div>
            Innings By Position
            `,
            colspan: 9,
            headerClass: 'th-title-header',
        },
    ]
    // eslint-disable-next-line no-new
    new Table({
        id: tableDivId,
        repeatHeader,
        secondaryHeaders,
        headers,
        highlightFalsy: true,
        data,
        uniqueId: 'player_id', // this can't have dashes in it
        defaultSort,
        defaultSortDirection,
        sortClass: 'column-sort',
        showRank: true,
        sortCallback(column, _, { state }) {
            const url = new URL(window.location)
            url.searchParams.set('sortColumn', column)
            url.searchParams.set('sortDirection', state)
            window.history.replaceState('', '', url.toString())
        },
    })
}

const $input = document.querySelector('.table-search')

if (data && data.length) {
    loadTable(currentData)

    if ($input) {
        $input.addEventListener('input', (e) => {
            currentData = getFilteredData(e.target.value)
            loadTable(currentData)
        })
    }
}

document.getElementById('leaderboard').addEventListener('change', (e) => {
    if (e.target.matches('.form-control')) {
        const id = e.target.getAttribute('id')
        const type = id.slice(3)
        const { selectedIndex } = e.target
        document.querySelector(`.label-change-${type}`).innerText =
            e.target.value === 'split'
                ? 'All - Split by Year'
                : e.target[selectedIndex].text
    }
})

function populateUrl() {
    const parameters = {
        year: document.getElementById('ddlYear').value,
        team: document.getElementById('ddlTeam').value,
        min: document.getElementById('ddlMin')?.value || '',
        pos: document.getElementById('ddlPos')?.value || '',
    }

    const urlParams = new URLSearchParams(parameters)

    return `${window.location.pathname}?${urlParams.toString()}`
}

document.addEventListener('click', (e) => {
    if (e.target.matches('.btn-update')) {
        window.location = populateUrl()
    }
})

function getFilteredData(search) {
    const normalized_search = search
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()

    return data.filter((d) => {
        const name = d.entity_name
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()

        return name.includes(normalized_search)
    })
}

document.getElementById('btn-csv').addEventListener('click', () => {
    window.location.href = window.location.search
        ? `${window.location.href}&csv=true`
        : `${window.location.href}?csv=true`
})
